import {makeAutoObservable} from 'mobx'
import AppStore from './AppStore'
import * as Api from '@/utils/api/api'

class DealStore {
    list = []
    PAGE_SIZE = 8
    pageSize = 8
    pageNum = 1

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 获取信息
     */
    async fetchList() {
        if (AppStore.hasLogin) {
            const {pageSize, pageNum} = this
            return Api.trackMap({
                pageSize,
                pageNum
            }).then((data) => {
                const {map, totalNum} = data;

                let list = []

                for (let key in map) {
                    for (let item of map[key]) {
                        if (list.length < 8) {
                            list.push(item)
                        }
                    }
                }

                this.list = list

                return data;
            })
        }
    }
}

const store = new DealStore()

export default store
